import {register} from '@shopify/theme-sections';

import initPagination from '../components/pagination';

register('blog-template', {
  onLoad() {
    initPagination(this.id);
  },
});
